import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastProvider } from './components/toast.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';

// Last-resort safety net for stuff that escapes the React tree (async
// rejections, sync errors from event handlers). Logs to the same endpoint
// the boundary uses so the server journal stays the one place to look.
function reportToServer(message, stack) {
  try {
    fetch("/api/log/client", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: String(message ?? "(no message)").slice(0, 500),
        stack: String(stack ?? "").slice(0, 4000),
        url: window.location.href,
        userAgent: navigator.userAgent,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* swallow */ }
}
window.addEventListener("error", (e) => reportToServer(e.message, e.error?.stack));
window.addEventListener("unhandledrejection", (e) =>
  reportToServer(e.reason?.message ?? e.reason, e.reason?.stack));

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
